import { render, staticRenderFns } from "./AllServicePartners.vue?vue&type=template&id=198abc00&scoped=true"
import script from "./AllServicePartners.vue?vue&type=script&lang=js"
export * from "./AllServicePartners.vue?vue&type=script&lang=js"
import style0 from "./AllServicePartners.vue?vue&type=style&index=0&id=198abc00&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "198abc00",
  null
  
)

export default component.exports